import TokenAvatar from '@components/TokenAvatar'
import useConfig from '@plug-core/hooks/useConfig'
import { EVMChain } from '@plug-core/interfaces/common'
import { useUserEVMChains } from '@plug-core/state'
import { ListGroup, ListRow, Switch } from '@ui'
import React from 'react'

interface IProps {
  chain: EVMChain
  isActive: boolean
  onDelete: (chainId: number) => void
  onAdd: (chain: number) => void
}

const ManageEVMListItem = ({ chain, isActive, onDelete, onAdd }: IProps) => {
  const onChange = () => {
    isActive ? onDelete(chain.chainId) : onAdd(chain.chainId)
  }

  return (
    <ListRow
      leading={<TokenAvatar logo={chain.icon} size={28} fallbackName={chain.symbol} />}
      primary={chain.name}
      trailing={
        <Switch
          aria-label={chain.name}
          disabled={false}
          onCheckedChange={onChange}
          checked={isActive}
        />
      }
    />
  )
}

export const ManageEVM = () => {
  const { evmChains } = useConfig()
  const { userEVMChains, addChain, removeChain } = useUserEVMChains()

  return (
    <div className="mb-3 flex flex-col gap-2">
      <ListGroup>
        {evmChains.map((chain) => (
          <ManageEVMListItem
            key={chain.chainId}
            chain={chain}
            isActive={userEVMChains.find((c) => c == chain.chainId) ? true : false}
            onDelete={removeChain}
            onAdd={addChain}
          />
        ))}
      </ListGroup>
    </div>
  )
}
